import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import { Accordion, CollapseCard, Typography } from "@totalsoft/rocket-ui";
import ScoringClassificationComponent from "./ScoringClassificationComponent";
import ScoringKnockoutCriteriaListContainer from "./ScoringKnockoutCriteriaListContainer";
import ScoringGridSummary from "./ScoringGridSummary";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";

export const ScoringGridComponent = ({ scoringGrid, dimensionPeriods, cardExpanded, onExpand }) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12}>
        <CollapseCard
          id="scoringGrid"
          icon={AssignmentTurnedIn}
          iconColor="primary"
          title={t(scoringGrid.name)}
          subheader={cardExpanded ? <></> : <ScoringGridSummary scoringGrid={scoringGrid} />}
          onToggle={(_, expanded) => onExpand(!expanded)}
          expanded={cardExpanded}
          toggleOnHeaderClick
        >
          <Grid item xs={12}>
            <Box ml={2} mb={2}>
              <ScoringGridSummary scoringGrid={scoringGrid} />
            </Box>
            <Box>
              {scoringGrid.classifications && scoringGrid.classifications.length > 0 && (
                <Accordion
                  content={scoringGrid.classifications.map(classification => ({
                    title: (
                      <Typography fontWeight="bold" fontSize="15px">
                        {classification.name}
                      </Typography>
                    ),
                    content: (
                      <ScoringClassificationComponent
                        documentScoringGridId={scoringGrid.documentScoringGridId}
                        disabled={true}
                        scoringClassification={classification}
                        indicatorPeriodList={scoringGrid.financialIndicatorPeriodDimensions || []}
                        dimensionPeriods={dimensionPeriods}
                      />
                    )
                  }))}
                />
              )}
            </Box>
          </Grid>
        </CollapseCard>
      </Grid>
      <Grid item xs={12}>
        {!!scoringGrid?.knockoutCriteria?.length && (
          <CollapseCard defaultExpanded title={t("Scoring.KnockoutCriteria.Title")} toggleOnHeaderClick>
            <ScoringKnockoutCriteriaListContainer knockoutCriteriaList={scoringGrid.knockoutCriteria} />
          </CollapseCard>
        )}
      </Grid>
    </Grid>
  );
};

ScoringGridComponent.propTypes = {
  scoringGrid: PropTypes.object.isRequired,
  dimensionPeriods: PropTypes.array,
  cardExpanded: PropTypes.bool.isRequired,
  onExpand: PropTypes.func
};

export default ScoringGridComponent;
